import React, { useState, useEffect } from "react";
import { useMediaQuery, Text, Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, useDisclosure } from "@chakra-ui/react";
import { AuthorProps } from "../../definitions/interfaces/GlobalInterfaces";
import { colors } from "../../definitions/constants/GlobalStyles";
import i18n from "../../i18n/i18n";

interface TruncatedTextProps {
  text: string;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({ text }) => {
  const [isMobile] = useMediaQuery("(max-width: 992px)");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const MAX_LENGTH = 200;

  const handleReadMoreClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onOpen();
  };

  const isLongText = text && text.length > MAX_LENGTH;
  const displayText = isLongText ? text.slice(0, MAX_LENGTH) + "..." : text;

  return (
    <>
      <Text
        fontSize="13px"
        fontWeight="400"
        lineHeight="18.51px"
        color={colors.figmaColors.grey3}
        p={isMobile ? "2" : "0"}
      >
        {displayText}
        {isLongText && (
          <span
            onClick={handleReadMoreClick}
            style={{
              color: colors.figmaColors.secColor,
              fontWeight: 600,
              cursor: "pointer",
              marginLeft: "5px",
            }}
          >
            {i18n.t("read_more", { defaultValue: "Ver más" })}
          </span>
        )}
      </Text>

      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent mx={isMobile ? "16px" : "auto"}>
          <ModalHeader fontSize="18px" color={colors.figmaColors.black}>
            {i18n.t("post_content", { defaultValue: "Contenido del post" })}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Text
              fontSize="14px"
              fontWeight="400"
              lineHeight="1.5"
              color={colors.figmaColors.grey3}
              whiteSpace="pre-wrap"
            >
              {text}
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export function PostText({ post }: AuthorProps) {
  return <TruncatedText text={post.post_text} />;
}

export default PostText;
